import ClientCache from "@/utils/login/ClientCache.ts";
import PlaceUtils from "@/utils/common/PlaceUtils.ts";
import CommonFieldIds from "@/utils/constants/CommonFieldIds.ts";
import AGGridColumnTemplate from "@/utils/UIConstants/AGGridColumns/AGGridColumnTemplate.ts";

export default class NamaMainFileWidgetUtils {
  static shouldShowImageOnHover(entity: string): boolean {
    let entityImageInfo: namaTypes.EntityMainFileInfo | null = ClientCache.getEntityImageInfo(entity);
    if (!entityImageInfo)
      return false;
    return entityImageInfo.showInPopupWithCode === true;
  }

  static linkWithMainImage(text: string, ref: Record<string, any>) {
    const linkToObject = PlaceUtils.linkToObject(ref);
    const entityType = ref[CommonFieldIds.ENTITY_TYPE];
    const id = ref[CommonFieldIds.ID];
    const colorCode = ref[CommonFieldIds.COLOR_CODE];
    const styleAttribute: Record<string, any> = {};
    let classStyle = "";
    if (colorCode) {
      styleAttribute.bg = `background-color:${colorCode};`
      styleAttribute.fg = `color:${AGGridColumnTemplate.getBestTextColor(colorCode)};`
    } else {
      classStyle = "tw-text-primary-light dark:tw-text-primary-dark";
    }
    return `<a class="${classStyle}" style='cursor: pointer;${styleAttribute.bg}${styleAttribute.fg}' href='${linkToObject}' title='${text}' ${this.previewImageCode(id, entityType)}>${text}</a>`;
  }

  static previewImageCode(entityType: string, id: string, attachId?: string) {
    if ((!id && !attachId) || !this.shouldShowImageOnHover(entityType))
      return "";/*TODO onmouseout='previewAttachmentMouseOut(this);' onmouseover='previewAttachment(this,"${attachId ? attachId : ""}","${entityType}","${id}");'*/
    return ``;
  }
}
